import axios from 'axios';
import { showErrorToast, showInfoToast, showSuccessToast } from './toastMessage';
import { getToken } from "./cookies";

const BaseURL = 'https://kaptanatamaapi.k8s.kamilkoc.com.tr/';
// const BaseURL = 'https://api.kamilkoc.com.tr/';

const ApiCall = async (url, method, params, mustAuth) => {
    const auth = mustAuth || false;
    const ServisURL = BaseURL + url;

    var headers = {
        "Content-Type": "application/json"
    }

    if (auth) {
        headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + getToken()
        }
    }


    // console.log(headers);
    // if (method.toString().toLowerCase() === 'get')
    //     return axios({
    //         url: ServisURL,
    //         method: method,
    //         headers: headers,
    //         params: params
    //     }).then((res) => {
    //         return res.data;
    //     }
    //     ).catch((err) => {
    //         showInfoToast(err.data);
    //         return err.data;
    //     });

    // else {
    //     return axios({
    //         url: ServisURL,
    //         method: method,
    //         headers: headers,
    //         data: params
    //     }).then((res) => {
    //         return res.data;
    //     }
    //     ).catch((err) => {
    //         showInfoToast(err.data);
    //         return err.data;
    //     });
    // }

    try {
        const response = await axios({
            url: BaseURL + url,
            method: method.toString().toLowerCase(),
            data: params,
            headers: headers
        });
        response.data.responseMessage === "" && showErrorToast(response.data.message);
        return response;
    } catch (error) {
        showErrorToast(error);
        return Promise.reject(error);
    }


}

export default ApiCall;